var lbl_confirm_delete_libraryitem = 'Weet u zeker dat u dit item wilt verwijderen?';

$(window).load(function(){
    $('.action_delete_libraryitem').click(function(){
         if(confirm(lbl_confirm_delete_libraryitem)){
             $('#form_delete_libraryitem').submit();
         }
    });
});